const TimeAccuracy = {
    hundredthsSeconds: 0.01,
    tenthsSeconds: 0.1,
    seconds: 1,
    minutes: 60,
    hours: 3600
};

export default TimeAccuracy;